import { connect } from "react-redux";
import PropTypes from "prop-types";

import BaseInputComponent from "basecomponents/BaseInputComponent";
import {
  InputField,
  TextArea,
  InputSelect,
  InputSelectSearch,
} from "../components/form";
import { SmallSpinner } from "../components/loaders";

// Utils
import {
  hideModal,
  initSearchSelect,
  setSearchSelectSelectedLabel,
} from "../utils/domUtils";
import { getArticleStatusOptions } from "../utils/packageUtils";
import {
  removeNullProperties,
  joinObjects,
  objectIsEmpty,
} from "../utils/jsonUtils";

// Actions
import {
  updateArticle,
  setEditArticleFromFunction,
} from "../actions/articleActions";

class AdminEditArticleModal extends BaseInputComponent {
  modal_id = "modal_edit_article";
  state = {
    id: null,
    name: "",
    track_code: "",
    description: "",
    status: "ST_WAITING",
    id_edit_client: 0,
    id_edit_package: 0,
    //
    statusOptions: [],
    clientOptions: [],
    packageOptions: [],
    needRefreshSelect: false,
    preventSetPackageOptions: false,
    //
    information_setted: false,
    prevent_set_state: false,
    errors: {},
  };

  componentDidMount() {
    this.setState({
      statusOptions: getArticleStatusOptions(),
    });
  }

  componentDidUpdate() {
    if (!this.state.needRefreshSelect) return;
    this.refreshDropDowns();
  }

  refreshDropDowns() {
    initSearchSelect({
      id: "id_edit_client",
      selectedValue: this.state.id_edit_client,
      onChange: (id_edit_client) => {
        const packageOptions = this.getPackageOptions(id_edit_client);
        this.setState({
          id_edit_client,
          packageOptions,
          id_edit_package: 0,
          needRefreshSelect: true,
          preventSetPackageOptions: true,
        });
      },
    });
    initSearchSelect({
      id: "id_edit_package",
      selectedValue: this.state.id_edit_package,
      onChange: (id_edit_package) => {
        this.setState({
          id_edit_package,
        });
      },
    });
    setSearchSelectSelectedLabel(
      "id_edit_client",
      this.state.id_edit_client,
      this.state.clientOptions,
      "Ninguno"
    );
    setSearchSelectSelectedLabel(
      "id_edit_package",
      this.state.id_edit_package,
      this.state.packageOptions,
      "Ninguno"
    );

    this.setState({
      needRefreshSelect: false,
    });
  }

  getPackageOptions = (id_client = null) => {
    // @ts-ignore
    const allPackages = this.props.package.elements;
    if (id_client === null || id_client === 0 || id_client === "0") {
      return allPackages.map((e) => ({
        value: e.id,
        label: `${e.id} ${e.name}`,
      }));
    }
    return allPackages
      .filter((p) => p.id_client === id_client)
      .map((e) => ({
        value: e.id,
        label: `${e.id} ${e.name}`,
      }));
  };

  static getDerivedStateFromProps(nextProps, currentState) {
    let newState = {
      errors: null,
      packageOptions: null,
      clientOptions: null,
      needRefreshSelect: false,
      changed: false,
    };
    if (nextProps.errors) {
      newState.errors = nextProps.errors;
      newState.changed = true;
    }

    if (
      nextProps.package?.elements &&
      nextProps.package.elements.length > 0 &&
      !currentState.preventSetPackageOptions &&
      currentState.packageOptions.length === 0
    ) {
      newState.packageOptions = nextProps.package.elements.map((e) => ({
        value: e.id,
        label: `${e.id} ${e.name}`,
      }));
      newState.needRefreshSelect = true;
      newState.changed = true;
    }

    if (
      nextProps.client?.elements &&
      nextProps.client.elements.length > 0 &&
      currentState.clientOptions.length === 0
    ) {
      newState.clientOptions = nextProps.client.elements.map((e) => ({
        value: e.id,
        label: `${e.code} ${e.name}`,
      }));
      newState.needRefreshSelect = true;
      newState.changed = true;
    }

    if (
      !objectIsEmpty(nextProps.article.item) &&
      !currentState.information_setted &&
      !currentState.prevent_set_state
    ) {
      newState = joinObjects(newState, nextProps.article.item);
      newState["id_edit_package"] = nextProps.article.item.id_package || 0;
      newState["id_edit_client"] = nextProps.article.item.id_client || 0;
      newState["needRefreshSelect"] = true;
      newState["information_setted"] = true;
    }

    if (!newState.changed) return null;

    return removeNullProperties(newState);
  }

  isLoading(): boolean {
    // @ts-ignore
    return this.props.article.loadingOperation;
  }

  clearForm = () => {
    this.setState(
      {
        name: "",
        track_code: "",
        description: "",
        status: "ST_WAITING",
        id_edit_client: 0,
        id_edit_package: 0,
        preventSetPackageOptions: false,
        needRefreshSelect: true,
        //
        information_setted: false,
        prevent_set_state: true,
      },
      () => {
        this.setState({
          prevent_set_state: false,
        });
      }
    );
  };

  onCancelClick = () => {
    // @ts-ignore
    this.props.setEditArticleFromFunction(null);
    this.clearForm();
    hideModal(this.modal_id);
  };

  onAcceptClick = () => {
    const {
      id,
      name,
      track_code,
      status,
      id_edit_client,
      id_edit_package,
      description,
    } = this.state;
    // @ts-ignore
    this.props.updateArticle(
      {
        id,
        name,
        track_code,
        status,
        id_client: id_edit_client,
        id_package: id_edit_package,
        description,
      },
      (success) => {
        if (!success) return;
        this.onCancelClick();
      }
    );
  };

  getForm = () => {
    const {
      name,
      track_code,
      description,
      status,
      id_edit_client,
      id_edit_package,
      //
      statusOptions,
      clientOptions,
      packageOptions,
      errors,
    } = this.state;
    const loading = this.isLoading();
    return (
      <>
        <div className="grid-2-col">
          <InputField
            id="article_name"
            name="name"
            value={name}
            label="Nombre"
            error={errors}
            onChange={this.onChangeTextInput}
          />
          <InputField
            id="article_track_code"
            name="track_code"
            value={track_code}
            label="Tracking"
            error={errors}
            onChange={this.onChangeTextInput}
          />
        </div>

        <InputSelect
          id="article_status"
          name="status"
          label="Estado"
          addNoneOption={false}
          value={status}
          options={statusOptions}
          onChange={this.onChangeTextInput}
        />

        <InputSelectSearch
          id="id_edit_client"
          value={id_edit_client}
          label="Cliente"
          error={errors}
          options={clientOptions}
        />
        <InputSelectSearch
          id="id_edit_package"
          value={id_edit_package}
          label="Paquete"
          error={errors}
          options={packageOptions}
        />

        <div>
          <TextArea
            id="article_description"
            name="description"
            label="Descripcion (opcional)"
            value={description}
            onChange={this.onChangeTextInput}
          />
        </div>

        {loading && <SmallSpinner center={true} />}
      </>
    );
  };

  render() {
    return (
      <div
        className="modal fade"
        id={this.modal_id}
        role="dialog"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Editar articulo</h5>
            </div>
            <div className="modal-body">{this.getForm()}</div>
            <div className="modal-footer">
              <div className="flex-2-separated">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={this.onCancelClick}
                >
                  Cancelar
                </button>

                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={this.onAcceptClick}
                >
                  Aceptar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// @ts-ignore
AdminEditArticleModal.propTypes = {
  article: PropTypes.object.isRequired,
  package: PropTypes.object.isRequired,
  client: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  updateArticle: PropTypes.func.isRequired,
  setEditArticleFromFunction: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  article: state.article,
  package: state.package,
  client: state.client,
  errors: state.errors,
});

export default connect(mapStateToProps, {
  updateArticle,
  setEditArticleFromFunction,
})(AdminEditArticleModal);
